import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * Wraps useNavigate to preserve embed=true query param across internal navigation.
 * When running in Teams as an embedded tab, all internal links keep embed mode
 * so the header stays hidden.
 */
export const useEmbedNavigate = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isEmbed = searchParams.get('embed') === 'true';

  return useCallback(
    (to: string) => {
      if (!isEmbed) {
        navigate(to);
        return;
      }
      // Preserve embed=true on the target URL
      const hasQuery = to.includes('?');
      const separator = hasQuery ? '&' : '?';
      navigate(`${to}${separator}embed=true`);
    },
    [navigate, isEmbed]
  );
};
